import React from "react";
import { useHistory } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import useStyles from "./style";

import KtpPass from "../../../../assets/icon/ktpPass.js";
import KtpRejc from "../../../../assets/icon/ktpRejc.js";
import KtpAcc from "../../../../assets/icon/ktpAcc.js";

function StatusPending() {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Container>
      <div
        style={{
          paddingTop: "150px",
        }}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <KtpPass />
          </Grid>
          <Grid item xs={12} className={classes.warpText}>
            <Typography className={classes.liquidPrimary}>
              Verifikasi akun sedang diproses
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.warpText}>
            <Typography className={classes.liquidSecondary}>
              Terima kasih telah melakukan verifikasi akun. Mohon menunggu,
              hasil verifikasi akan segera kami konfirmasi.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => history.push("/")}
            >
              Lanjut transaksi
            </Button>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
}

function Statusreject({ setIsForm, verifikasiData }) {
  const classes = useStyles();

  const handleVerifikasi = () => {
    setIsForm(true);
  };
  return (
    <Container>
      <div
        style={{
          paddingTop: "150px",
        }}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <KtpRejc />
          </Grid>
          <Grid item xs={12} className={classes.warpText}>
            <Typography className={classes.liquidPrimary}>
              Verifikasi akun gagal
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.warpText}>
            <Typography className={classes.liquidSecondary}>
              Maaf verifikasi akun gagal,{" "}
              <span
                style={{
                  color: "#CF000F",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                }}
              >
                {verifikasiData?.keterangan ? verifikasiData?.keterangan : ""}
              </span>{" "}
              dimohon untuk melakukan verifikasi akun kembali
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleVerifikasi}
              size="small"
            >
              Verifikasi Ulang
            </Button>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
}
function StatusAcc() {
  const classes = useStyles();

  return (
    <Container>
      <div
        style={{
          paddingTop: "150px",
        }}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <KtpAcc />
          </Grid>
          <Grid item xs={12} className={classes.warpText}>
            <Typography className={classes.liquidPrimary}>
              Verifikasi akun berhasil
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.warpText}>
            <Typography className={classes.liquidSecondary}>
              Terima kasih telah melakukan verifikasi akun. Silakan melanjutkan
              transaksi. Happy Selling!
            </Typography>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
}

function VerifyStatus({ verifikasiData, setIsForm }) {
  if (
    verifikasiData.isRejected === false &&
    verifikasiData.isVerified === false
  ) {
    return <StatusPending />;
  } else if (
    verifikasiData.isRejected === true &&
    verifikasiData.isVerified === false
  ) {
    return (
      <Statusreject verifikasiData={verifikasiData} setIsForm={setIsForm} />
    );
  } else if (
    verifikasiData.isRejected === false &&
    verifikasiData.isVerified === true
  ) {
    return <StatusAcc />;
  }
  return null;
}

export default VerifyStatus;
